module.exports = __webpack_public_path__ + "img/1f4aa.f325a6b.svg";